import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"

function PostNavigation({ next, prev }) {
    return (
        <div className="post-navigation sm:border-b sm:border-[#D9D9D9] flex flex-row pt-5 font-['Work_Sans'] text-[10px] leading-[14px] md:text-[18px] md:leading-9 lg:py-10">
            <div className="prev-post w-full">
                {prev ? (
                    <Link
                        to={`/blog/${prev?.slug}`}
                        className="flex w-full flex-col"
                    >
                        <div className="hidden w-full lg:block">
                            {prev?.featuredImage ? (
                                <GatsbyImage
                                    image={getImage(
                                        prev?.featuredImage?.node?.localFile
                                    )}
                                    alt={prev?.featuredImage?.node?.altText}
                                    className="mb-3 h-[200px] w-[80%] "
                                    objectFit="fixed"
                                />
                            ) : (
                                <img
                                    lazy
                                    src="/image-og.jpg"
                                    className="h-full w-full"
                                    alt="Previous Post"
                                />
                            )}
                        </div>
                        <div className="w-[80%] lg:w-3/5">
                            <p className="text-[#8C8C8C]">Previous Post:</p>
                            <p className="font-medium md:font-semibold">
                                {prev?.title}
                            </p>
                        </div>
                    </Link>
                ) : (
                    ""
                )}
            </div>
            <div className="next-post w-full">
                {next ? (
                    <Link
                        to={`/blog/${next?.slug}`}
                        className="flex w-full flex-row items-end justify-end lg:flex-col"
                    >
                        <div className="hidden w-full justify-end lg:flex">
                            {next?.featuredImage ? (
                                <GatsbyImage
                                    image={getImage(
                                        next?.featuredImage?.node?.localFile
                                    )}
                                    alt={next?.featuredImage?.node?.altText}
                                    className="mb-3 h-[200px] w-[80%]"
                                    objectFit="fixed"
                                />
                            ) : (
                                <img
                                    lazy
                                    src="/image-og.jpg"
                                    className="h-full w-full"
                                    alt="Next Post"
                                />
                            )}
                        </div>
                        <div className="w-[80%] text-right lg:w-3/5">
                            <p className="text-[#8C8C8C]">Next Post:</p>
                            <p className="font-medium md:font-semibold">
                                {next?.title}
                            </p>
                        </div>
                    </Link>
                ) : (
                    ""
                )}
            </div>
        </div>
    )
}

export default PostNavigation
